import React from 'react';
import PropTypes from 'prop-types';
import UserProp from '../../propTypes/userProp';
import { displayUserName } from '../../../services/utilityFunctions';

export default function UserColumn({
  t,
  user,
  smallFormat,
  includeInvitedStatus,
  invitedText,
  showUserName,
}) {
  const avatar =
    user.image && user.image.thumb ? user.image.thumb : '/images/no_user.png';
  let customStyle = {};
  if (smallFormat) {
    customStyle = {
      marginTop: 0,
      marginBottom: 0,
    };
  }
  const badgeClass = `user-column__invited ${
    user.status === UserProp.STATUS.LIMITED ? 'user-column__limited' : ''
  }`;
  const defaultText =
    user.status === UserProp.STATUS.INVITED
      ? t('pending_registration')
      : t('limited');
  const showBadge =
    includeInvitedStatus &&
    (user.status === UserProp.STATUS.INVITED ||
      user.status === UserProp.STATUS.LIMITED);
  return (
    <div className="user-column" style={customStyle}>
      <div className="users-thumb">
        <img src={avatar} alt="user avatar" />
      </div>
      <div
        className="user-column__info"
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <div className="user-column__username">
          {displayUserName(user, showUserName)}
        </div>
        {showBadge && (
          <div className={badgeClass}>
            <span>{invitedText || defaultText}</span>
          </div>
        )}
      </div>
    </div>
  );
}

UserColumn.propTypes = {
  user: PropTypes.shape(UserProp.propType).isRequired,
  smallFormat: PropTypes.bool,
  t: PropTypes.func.isRequired,
  includeInvitedStatus: PropTypes.bool,
  showUserName: PropTypes.bool,
  invitedText: PropTypes.string,
};

UserColumn.defaultProps = {
  smallFormat: false,
  includeInvitedStatus: false,
  invitedText: null,
  showUserName: false,
};
